import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import AppProvider from './hooks';

import Routes from './routes';

import { theme } from './styles/theme';

import './styles/global.css';

const App: React.FC = () => (
  <ChakraProvider theme={theme}>
    <Router>
      <AppProvider>
        <Routes />
      </AppProvider>
    </Router>
  </ChakraProvider>
);

export default App;
